"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataListState = exports.DataListBulkMenuState = exports.DataListFilterState = exports.DataListSettingsState = void 0;
var mobx_1 = require("mobx");
var urls_1 = require("../../urls");
var App_1 = require("../../App");
var contexts_1 = require("../../interfaces/contexts");
var $ = require("jquery");
var columns_1 = require("../editableList/columns");
var utils_1 = require("../editableList/utils");
var DataListSettingsState = (function () {
    function DataListSettingsState(base_url) {
        this.data = [];
        this.cached_page_size = null;
        this.url = base_url + "list-settings/";
    }
    DataListSettingsState.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, settings_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    settings_url = (0, urls_1.resolve)(this.url, context.project);
                    return [2, $.get({ url: settings_url, contentType: "application/json" })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            _this.data = data.settings;
                            _this.cached_page_size = data.settings.filter(function (d) { return d.name == "page_size"; })[0].value;
                        })];
                }
                else {
                    throw new Error("Cannot fetch settings outside of scope context");
                }
                return [2];
            });
        });
    };
    DataListSettingsState.prototype.update = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var self, search, params, context, settings_url;
            return __generator(this, function (_a) {
                self = this;
                if (this.cached_page_size && (data.page_size) != this.cached_page_size) {
                    search = new URLSearchParams(window.location.search);
                    search.delete("page");
                    params = "?" + search.toString();
                    window.history.pushState(null, null, window.location.pathname + params);
                }
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    settings_url = (0, urls_1.resolve)(this.url, context.project);
                    return [2, $.post({
                            url: settings_url, data: JSON.stringify(data),
                            contentType: 'application/json'
                        }).then(function () {
                            self.cached_page_size = (data.page_size);
                            notification(gettext("List settings successfully saved"));
                        }, function () {
                            notification(gettext("Server Error"), {
                                type: "error",
                            });
                        })];
                }
                else {
                    throw new Error("Cannot update list settings outside of scope context");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], DataListSettingsState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], DataListSettingsState.prototype, "fetchData", null);
    __decorate([
        mobx_1.action
    ], DataListSettingsState.prototype, "update", null);
    return DataListSettingsState;
}());
exports.DataListSettingsState = DataListSettingsState;
var DataListFilterState = (function () {
    function DataListFilterState(base_url) {
        this.url = base_url + "filter-state/";
    }
    DataListFilterState.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, filter_state_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    filter_state_url = (0, urls_1.resolve)(this.url, context.project);
                    return [2, $.get({ url: filter_state_url, contentType: "application/json" })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            _this.data = data;
                        })];
                }
                else {
                    throw new Error("Cannot fetch filter state outside of scope context");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], DataListFilterState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], DataListFilterState.prototype, "fetchData", null);
    return DataListFilterState;
}());
exports.DataListFilterState = DataListFilterState;
var DataListBulkMenuState = (function () {
    function DataListBulkMenuState(base_url) {
        this.url = base_url + "bulk-update-state/";
    }
    DataListBulkMenuState.prototype.fetchData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var context, scope_id;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    scope_id = context.project;
                    return [2, $.get({
                            url: (0, urls_1.resolve)(this.url, scope_id),
                            data: data,
                            contentType: "application/json"
                        }).then(function (state) {
                            _this.data = state;
                        })];
                }
                else {
                    throw new Error("Cannot fetch bulk update state outside of scope context");
                }
                return [2];
            });
        });
    };
    DataListBulkMenuState.prototype.getFetchDataMethod = function () {
        return this.fetchData.bind(this);
    };
    __decorate([
        mobx_1.observable
    ], DataListBulkMenuState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], DataListBulkMenuState.prototype, "fetchData", null);
    return DataListBulkMenuState;
}());
exports.DataListBulkMenuState = DataListBulkMenuState;
var DataListState = (function () {
    function DataListState(base_url) {
        this.data = {
            columns: [],
            headers: [],
            rows: [],
            ordering: [],
            paginator: {
                leading: [],
                lookahead: 5,
                next: null,
                page: 1,
                page_count: 1,
                page_size: 50,
                previous: null,
                trailing: [],
                items: 0
            },
            read_only: false,
            has_business_model: false,
            bulk_edit_fields: [],
            quick_add_fields: [],
        };
        this.base_url = base_url;
        this.settings = new DataListSettingsState(this.base_url);
        this.filter_state = new DataListFilterState(this.base_url);
        this.bulk_menu_state = new DataListBulkMenuState(this.base_url);
    }
    DataListState.prototype.createNew = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var context, scope_id;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    scope_id = context.project;
                    return [2, $.post({
                            url: (0, urls_1.resolve)(this.base_url, scope_id),
                            data: JSON.stringify(data),
                            contentType: 'application/json'
                        })];
                }
                else {
                    throw new Error("Cannot create outside of scope context");
                }
                return [2];
            });
        });
    };
    DataListState.prototype.updateRows = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var context, scope_id, update_url;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    scope_id = context.project;
                    update_url = this.base_url + "bulk-update/";
                    return [2, $.post({
                            url: (0, urls_1.resolve)(update_url, scope_id),
                            data: JSON.stringify(data),
                            contentType: 'application/json'
                        })];
                }
                else {
                    throw new Error("Cannot update outside of scope context");
                }
                return [2];
            });
        });
    };
    DataListState.prototype.uploadFileContent = function (object_id, content) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2];
        }); });
    };
    DataListState.prototype.fetchData = function (query_string) {
        return __awaiter(this, void 0, void 0, function () {
            var self, context, scope_id, list_url;
            return __generator(this, function (_a) {
                self = this;
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    scope_id = context.project;
                    list_url = (0, urls_1.resolve)(this.base_url, scope_id);
                    list_url += query_string ? query_string : "";
                    return [2, $.get({ url: list_url, contentType: "application/json" })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            data.columns = data.columns.map(function (column) {
                                return (0, columns_1.dispatchColumn)(column);
                            });
                            var rows = [];
                            data.rows.map(function (row) {
                                rows.push((0, utils_1.dispatchRow)(row));
                            });
                            data.rows = rows;
                            self.data = data;
                        })];
                }
                else {
                    throw new Error("Cannot fetch list outside of scope context");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], DataListState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], DataListState.prototype, "createNew", null);
    __decorate([
        mobx_1.action
    ], DataListState.prototype, "updateRows", null);
    __decorate([
        mobx_1.action
    ], DataListState.prototype, "uploadFileContent", null);
    __decorate([
        mobx_1.action
    ], DataListState.prototype, "fetchData", null);
    return DataListState;
}());
exports.DataListState = DataListState;
